export const c_spinner_diameter = {
  "name": "--pf-v5-c-spinner--diameter",
  "value": "3.375rem",
  "var": "var(--pf-v5-c-spinner--diameter)"
};
export default c_spinner_diameter;